import {EditEmployeeFormValues} from './schema';

export type EditEmployeeFieldConfig = {
    name: keyof EditEmployeeFormValues;
    labelKey: string;
    type?: 'email' | 'tel';
};

export const EDIT_EMPLOYEE_FIELD_ROWS: EditEmployeeFieldConfig[][] = [
    [
        {name: 'firstName', labelKey: 'first_name'},
        {name: 'lastName', labelKey: 'last_name'},
    ],
    [
        {name: 'email', labelKey: 'email', type: 'email'},
        {name: 'phone', labelKey: 'phone', type: 'tel'},
    ],
];

export const EDIT_EMPLOYEE_FIELDS_I18N = 'page_employers_control.edit_employee.fields';
